import { faCaretRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import withRouter from "Common/withRouter";
import useMenuData from "Layout/LayoutMenuData";
import PropTypes from "prop-types";
import { useEffect, useState } from "react";
import { withTranslation } from "react-i18next";
import { Link } from "react-router-dom";

const HorizontalLayout = (props: any) => {
  const { menuItems, loadingStats } = useMenuData();
  const [openMenus, setOpenMenus] = useState<{ [key: string]: boolean }>({});

  /**
   * Toggle menu with smooth height + opacity animation
   */
  const toggleMenu = (id: string, e: React.MouseEvent) => {
    e.stopPropagation();

    setOpenMenus((prev) => {
      const isOpening = !prev[id]; // new state for this id
      const newState: { [key: string]: boolean } = {};

      // close all menus first
      Object.keys(prev).forEach((key) => {
        newState[key] = false;
        const el = document.getElementById(`submenu-${key}`);
        if (el) {
          el.style.maxHeight = "0px";
          el.style.opacity = "0";
        }
      });

      // then handle this submenu
      newState[id] = isOpening;

      setTimeout(() => {
        const el = document.getElementById(`submenu-${id}`);
        if (el) {
          if (isOpening) {
            el.style.maxHeight = `${el.scrollHeight}px`;
            el.style.opacity = "1";
          } else {
            el.style.maxHeight = "0px";
            el.style.opacity = "0";
          }
        }
      }, 50);

      return newState;
    });
  };

  /**
   * Handle menu position on hover (for dropdown alignment)
   */
  useEffect(() => {
    window.dispatchEvent(new Event("resize"));

    const menuItem = (e: any) => {
      const dropdownMenu = e.target;
      const subMenus =
        dropdownMenu.nextElementSibling ||
        dropdownMenu.parentElement.nextElementSibling;

      if (dropdownMenu && subMenus) {
        const dropdownOffset = subMenus.getBoundingClientRect();
        const dropdownWidth = subMenus.offsetWidth;
        const dropdownHeight = subMenus.offsetHeight;

        const screenWidth = window.innerWidth;
        const screenHeight = window.innerHeight;

        const maxDropdownX = dropdownOffset.left + dropdownWidth + 100;
        const maxDropdownY = dropdownOffset.top + dropdownHeight + 100;

        const isDropdownOffScreen =
          maxDropdownX > screenWidth || maxDropdownY > screenHeight;

        if (isDropdownOffScreen) {
          if (subMenus.classList.contains("menu-dropdown")) {
            subMenus.classList.add("dropdown-custom-right");
          }
        }
      }
    };

    const menuPosSetOnClicknHover = () => {
      const isElements = document.querySelectorAll(
        "#navbar-nav > li.nav-item"
      );
      Array.from(isElements).forEach(function (item) {
        item.addEventListener("click", menuItem, false);
        item.addEventListener("mouseover", menuItem, false);
      });
    };

    menuPosSetOnClicknHover();

    return () => {
      const isElements = document.querySelectorAll(
        "#navbar-nav > li.nav-item"
      );
      Array.from(isElements).forEach(function (item) {
        item.removeEventListener("click", menuItem, false);
        item.removeEventListener("mouseover", menuItem, false);
      });
    };
  }, []);

  /**
   * Activate menu item based on current route
   */
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });

    const initMenu = () => {
      const pathName = process.env.PUBLIC_URL + props.router.location.pathname;
      const ul: any = document.getElementById("navbar-nav");

      if (!ul) return;

      const items = ul.getElementsByTagName("a");
      let itemsArray = [...items];
      removeActivation(itemsArray);
      let matchingMenuItem = itemsArray.find((x) => {
        return x.pathname === pathName;
      });
      if (matchingMenuItem) {
        activateParentDropdown(matchingMenuItem);
      }
    };

    const timer = setTimeout(initMenu, 0);

    return () => clearTimeout(timer);
  }, [props.router.location.pathname, props.layoutType]);

  function activateParentDropdown(item: any) {
    item.classList.add("active");
    let parentCollapseDiv = item.closest(".collapse.menu-dropdown");

    if (parentCollapseDiv) {
      parentCollapseDiv.classList.add("show");
      parentCollapseDiv.parentElement.children[0].classList.add("active");
      parentCollapseDiv.parentElement.children[0].setAttribute(
        "aria-expanded",
        "true"
      );
      if (parentCollapseDiv.parentElement.closest(".collapse.menu-dropdown")) {
        parentCollapseDiv.parentElement
          .closest(".collapse")
          .classList.add("show");
        var parentElementDiv =
          parentCollapseDiv.parentElement.closest(".collapse")
            .previousElementSibling;
        if (parentElementDiv)
          if (parentElementDiv.closest(".collapse"))
            parentElementDiv.closest(".collapse").classList.add("show");
        parentElementDiv.classList.add("active");
        var parentElementSibling =
          parentElementDiv.parentElement.parentElement.parentElement
            .previousElementSibling;
        if (parentElementSibling) {
          parentElementSibling.classList.add("active");
        }
      }
      return false;
    }
    return false;
  }

  const removeActivation = (items: any) => {
    let actiItems = items.filter((x: any) => x.classList.contains("active"));

    actiItems.forEach((item: any) => {
      if (item.classList.contains("menu-link")) {
        if (!item.classList.contains("active")) {
          item.setAttribute("aria-expanded", false);
        }
        if (item.nextElementSibling) {
          item.nextElementSibling.classList.remove("show");
        }
      }
      if (item.classList.contains("nav-link")) {
        if (item.nextElementSibling) {
          item.nextElementSibling.classList.remove("show");
        }
        item.setAttribute("aria-expanded", false);
      }
      item.classList.remove("active");
    });
  };

  if (loadingStats) {
    return (
      <div className="sidebar-wrapper">
        <ul className="nav flex-column mt-1">
          {[...Array(5)].map((_, key) => (
            <li className="nav-item" key={key}>
              <div className="nav-link d-flex justify-content-between align-items-center">
                <div className="d-flex align-items-center flex-grow-1">
                  <div className="skeleton-icon me-2"></div>
                  <div className="skeleton-text fw-bold"></div>
                </div>
                <div className="skeleton-caret ms-2"></div>
              </div>

              {/* Submenu skeleton */}
              <div className="submenu-skeleton">
                <ul
                  className="nav nav-sm flex-column"
                  style={{ paddingLeft: "1.4rem" }}
                >
                  {[...Array(3)].map((_, subKey) => (
                    <li className="nav-item" key={subKey}>
                      <div className="skeleton-submenu-link"></div>
                    </li>
                  ))}
                </ul>
              </div>
            </li>
          ))}
        </ul>
      </div>
    );
  }

  return (
    <div className="sidebar-wrapper">
      <ul className="nav flex-column mt-1" id="navbar-nav">
        {(menuItems || []).map((item: any, key: number) => (
          <li className="nav-item" key={key} id={`menu-item-${item.id}`}>
            <div
              className={`nav-link d-flex justify-content-between align-items-center ${
                (item.id === "dashboard" || item.id === "report") &&
                props.router.location.pathname === item.link
                  ? "active"
                  : ""
              }`}
              style={
                (item.id === "dashboard" || item.id === "report") &&
                props.router.location.pathname === item.link
                  ? { borderRadius: "4px" }
                  : {}
              }
              onClick={(e) => item.subItems && toggleMenu(item.id, e)}
            >
              {item.subItems ? (
                <button
                  type="button"
                  onClick={(e) => toggleMenu(item.id, e)}
                  className="bg-transparent border-0 text-start text-reset p-0 d-flex align-items-center flex-grow-1"
                  style={{ boxShadow: "none" }}
                >
                  {item.icon && <i className={`${item.icon} me-2`}></i>}
                  <span className="fw-bold">{item.label}</span>
                </button>
              ) : (
                <Link
                  to={item.link || "#"}
                  className={`nav-link d-flex align-items-center text-reset flex-grow-1  ${
                    item.id === "dashboard" &&
                    props.router.location.pathname === item.link
                      ? "active"
                      : ""
                  }`}
                  style={{ padding: "0px" }}
                >
                  {item.icon && <i className={`${item.icon} me-2`}></i>}
                  <span className="fw-bold">{item.label}</span>
                </Link>
              )}
              {item.subItems && (
                <span
                  role="button"
                  onClick={(e) => toggleMenu(item.id, e)}
                  className="ms-2"
                >
                  <FontAwesomeIcon
                    icon={faCaretRight}
                    className={`transition-icon ${
                      openMenus[item.id] ? "rotate-icon" : ""
                    }`}
                  />
                </span>
              )}
            </div>

            {item.subItems && (
              <div
                id={`submenu-${item.id}`}
                className={`submenu-collapse ${openMenus[item.id] ? "open" : ""}`}
                style={{
                  maxHeight: openMenus[item.id] ? "1000px" : "0px",
                  opacity: openMenus[item.id] ? "1" : "0",
                  overflow: "hidden",
                  transition: "all 0.3s ease",
                }}
              >
                <ul
                  className="nav nav-sm flex-column"
                  style={{ paddingLeft: "1.4rem" }}
                >
                  {item.subItems.map((subItem: any, subKey: number) => (
                    <li className="nav-item" key={subKey}>
                      <Link
                        to={subItem.link || "/#"}
                        className="nav-link"
                        onClick={() => {
                          if (window.innerWidth <= 768) {
                            window.dispatchEvent(
                              new Event("closeSidebarOnMobile")
                            );
                          }
                        }}
                      >
                        {subItem.label}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
};

HorizontalLayout.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
};

export default withRouter(withTranslation()(HorizontalLayout));
